<script setup>
const props = defineProps({
  name: { type: String, required: true },
})

// A látványterv narancs vonalas ikonjai. Amire van heroicons megfelelő, azt
// használjuk; a tartály/víz ikonokat saját SVG adja.
const heroicons = {
  gear: 'i-heroicons-cog-6-tooth',
  circuit: 'i-heroicons-cpu-chip',
  'check-list': 'i-heroicons-clipboard-document-check',
  document: 'i-heroicons-document-text',
  pharma: 'i-heroicons-beaker',
  'shield-check': 'i-heroicons-shield-check',
  pipe: 'i-heroicons-wrench-screwdriver',
  corrosion: 'i-heroicons-shield-exclamation',
  daf: 'i-heroicons-square-3-stack-3d',
}

const heroicon = computed(() => heroicons[props.name])
</script>

<template>
  <span class="inline-flex items-center justify-center w-10 h-10" aria-hidden="true">
    <UIcon v-if="heroicon" :name="heroicon" class="w-full h-full" />

    <!-- Nyomástartó edény: álló henger domború fedelekkel -->
    <svg v-else-if="name === 'pressure-vessel'" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full">
      <path d="M14 14c0-3 4-5 10-5s10 2 10 5v20c0 3-4 5-10 5s-10-2-10-5V14z" />
      <path d="M14 14c0 3 4 5 10 5s10-2 10-5" />
      <circle cx="24" cy="27" r="3" />
      <path d="M18 39v4M30 39v4M34 20h5M34 28h5" />
    </svg>

    <!-- Víztisztítás: cseppek és vízszint -->
    <svg v-else-if="name === 'water'" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full">
      <path d="M24 6c3 5 5 8 5 11a5 5 0 0 1-10 0c0-3 2-6 5-11z" />
      <path d="M15 20c2 3.5 3.5 5.5 3.5 7.5a3.5 3.5 0 0 1-7 0c0-2 1.5-4 3.5-7.5z" />
      <path d="M33 20c2 3.5 3.5 5.5 3.5 7.5a3.5 3.5 0 0 1-7 0c0-2 1.5-4 3.5-7.5z" />
      <path d="M8 36c4-3 7-3 11 0s7 3 11 0 7-3 10 0" />
      <path d="M8 42c4-3 7-3 11 0s7 3 11 0 7-3 10 0" />
    </svg>

    <!-- Egyedi tartály: álló tartály létrával -->
    <svg v-else-if="name === 'tank'" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full">
      <path d="M12 14h20v24H12z" />
      <path d="M12 14c0-2.5 4.5-4 10-4s10 1.5 10 4" />
      <path d="M12 38c0 2.5 4.5 4 10 4s10-1.5 10-4" />
      <path d="M22 8v-3M36 16v22M41 16v22M36 21h5M36 27h5M36 33h5" />
    </svg>

    <!-- Ismeretlen név: üres, de nem tör el a layout -->
    <svg v-else viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" class="w-full h-full">
      <rect x="10" y="10" width="28" height="28" rx="4" />
    </svg>
  </span>
</template>
